module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "infos__raw"
  }, [_c('div', {
    staticClass: "infos__item info--icon info--time"
  }, [_c('timer', {
    attrs: {
      "currentFarm": _vm.currentFarm
    }
  })], 1)]), _c('div', {
    staticClass: "infos__raw"
  }, [(_vm.currentFarm.lastIndicators[0].temperature) ? _c('div', {
    staticClass: "infos__item"
  }, [_c('temperature', {
    attrs: {
      "info": _vm.currentFarm.lastIndicators[0].temperature,
      "tabindex": "0",
      "aria-label": "Temperature"
    }
  })], 1) : _vm._e(), (_vm.currentFarm.lastIndicators[0].solar_radiation) ? _c('div', {
    staticClass: "infos__item"
  }, [_c('uv', {
    attrs: {
      "info": _vm.currentFarm.lastIndicators[0].solar_radiation,
      "tabindex": "0",
      "aria-label": "UV exposure"
    }
  })], 1) : _vm._e(), (_vm.currentFarm.lastIndicators[0].humidity) ? _c('div', {
    staticClass: "infos__item"
  }, [_c('humidity', {
    attrs: {
      "info": _vm.currentFarm.lastIndicators[0].humidity,
      "tabindex": "0",
      "aria-label": "Humidity"
    }
  })], 1) : _vm._e(), (_vm.currentFarm.lastIndicators[0].rainfall) ? _c('div', {
    staticClass: "infos__item"
  }, [_c('rainfall', {
    attrs: {
      "info": _vm.currentFarm.lastIndicators[0].rainfall,
      "tabindex": "0",
      "aria-label": "Rainfall"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a083b930", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a083b930"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infos/InfosComponent.vue
// module id = 831
// module chunks = 0